var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["help/templates/emailsignup.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/form-validation.j2", false, "help/templates/emailsignup.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayGeneralErrors")) {
var t_4 = t_1.displayGeneralErrors;
} else {
cb(new Error("cannot import 'displayGeneralErrors'")); return;
}
context.setVariable("displayGeneralErrors", t_4);
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_5 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_5);
if(t_1.hasOwnProperty("hasErrors")) {
var t_6 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_6);
if(t_1.hasOwnProperty("validatedField")) {
var t_7 = t_1.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_7);
output += "<div class=\"o-row dom-anonymous-email-signup\">\n    ";
var t_8;
t_8 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"featureConfigs")),"helpAnonymousEmailSubscriptions");
frame.set("featureConfig", t_8, true);
if(frame.topLevel) {
context.setVariable("featureConfig", t_8);
}
if(frame.topLevel) {
context.addExport("featureConfig", t_8);
}
output += "\n\n    <div class=\"o-column o-extra-small--12 o-medium--8 o-large--5 u-no-gutters\">\n        <form novalidate action=\"#\" method=\"post\" class=\"c-form js-anonymous-email-signup-form\">\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"emailSignUp")),"signUpSuccessful")) {
output += "\n                <p class=\"c-form__success\" data-qa-success-msg>\n                    ";
output += runtime.suppressValue((lineno = 10, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-success-message",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n                </p>\n            ";
;
}
output += "\n\n            ";
if((lineno = 14, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "help"),"emailSignUp.error.generalErrors"]))) {
output += "\n                ";
output += runtime.suppressValue((lineno = 15, colno = 37, runtime.callWrap(t_4, "displayGeneralErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"emailSignUp")),"error")),"generalErrors")])), env.opts.autoescape);
output += "\n            ";
;
}
output += "\n\n            <div class=\"c-form__field ";
output += runtime.suppressValue((lineno = 18, colno = 48, runtime.callWrap(t_6, "hasErrors", context, [(lineno = 18, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "help"),"emailSignUp.error.emailAddress"]))])), env.opts.autoescape);
output += "\">\n                <label for=\"email-signup-email-address\" class=\"c-form__label\">";
output += runtime.suppressValue((lineno = 19, colno = 80, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-email-address-label",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "</label>\n                <input data-qa-email-signup-email-field id=\"email-signup-email-address\"\n                       class=\"c-form__email js-email-signup-email-address\"\n                       type=\"email\"\n                       name=\"emailAddress\"\n                       ";
output += runtime.suppressValue((lineno = 24, colno = 38, runtime.callWrap(t_7, "validatedField", context, ["ERROR_EMAIL_SIGNUP_INVALID_USERNAME"])), env.opts.autoescape);
output += "\n                       value=\"";
output += runtime.suppressValue((lineno = 25, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "help"),"emailSignUp.formData.emailAddress"])), env.opts.autoescape);
output += "\"\n                       aria-describedby=\"email-signup-email-address_error\" />\n                ";
output += runtime.suppressValue((lineno = 27, colno = 35, runtime.callWrap(t_5, "displayFieldErrors", context, [(lineno = 27, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"emailSignUp"),"error.emailAddress"])),runtime.makeKeywordArgs({"id": "email-signup-email-address"})])), env.opts.autoescape);
output += "\n            </div>\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "featureConfig")),"showGenderCaptureForEmailSignUp")) {
output += "\n                <div class=\"c-form__field\">\n                    <label for=\"email-signup-gender\" class=\"c-form__label\">";
output += runtime.suppressValue((lineno = 32, colno = 77, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-gender-label",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "</label>\n                    <select data-qa-email-signup-gender-dropdown id=\"email-signup-gender\"\n                            class=\"c-form__select js-email-signup-gender\"\n                            name=\"gender\">\n                            <option value=\"U\">";
output += runtime.suppressValue((lineno = 36, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["gender_values-unknown",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "</option>\n                            <option value=\"M\">";
output += runtime.suppressValue((lineno = 37, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["gender_values-male",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "</option>\n                            <option value=\"F\">";
output += runtime.suppressValue((lineno = 38, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["gender_values-female",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "</option>\n                    </select>\n                </div>\n            ";
;
}
else {
output += "\n                <input type=\"hidden\" name=\"gender\" value=\"U\" />\n            ";
;
}
output += "\n\n            <input type=\"hidden\" class=\"js-email-signup-source\" name=\"email-signup-subscription-source\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "featureConfig")),"source"), env.opts.autoescape);
output += "\" />\n\n            <div class=\"o-row o-column o-extra-small--12 o-medium--8 o-large--5\">\n\n                <div class=\"c-form__field\">\n                    <button class=\"c-button-primary js-sign-up-button\" type=\"submit\" data-qa-email-signup-submit>";
output += runtime.suppressValue((lineno = 50, colno = 115, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-subscribe-button-label",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "</button>\n                </div>\n\n            </div>\n\n        </form>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["help/templates/emailsignup.j2"] , dependencies)